const comments = [
  {
    name: '光影追梦人',
    text: '用了老子影视网大半年了，画质真的没话说，4K超清看着就是舒服。而且全集播放太方便了，不用一集一集等更新，周末窝在家一天刷完一部剧的快乐谁懂！',
    date: '2026-07-28',
    rating: 5,
  },
  {
    name: '剧荒拯救者',
    text: '朋友推荐的这个网站，没想到资源这么全。想看的电影电视剧基本都有，高清画质还不缓冲，比那些要注册充会员的强太多了。',
    date: '2026-07-25',
    rating: 5,
  },
  {
    name: '电影老炮儿',
    text: '作为一个看了二十多年电影的老影迷，老子影视网的片库确实让我惊喜。很多经典老片的高清版本都能找到，更新速度也快，新片上线很及时。',
    date: '2026-07-22',
    rating: 4,
  },
  {
    name: '追剧小能手',
    text: '手机上看也很流畅！以前用别的网站老卡顿，老子影视网真的做到了秒开不缓冲，超清画质在大屏上也清清楚楚。已经安利给身边所有追剧的姐妹了。',
    date: '2026-07-20',
    rating: 5,
  },
  {
    name: '深夜观影人',
    text: '最满意的是不需要注册就能看，太省心了。专题合集做得也不错，周末不知道看什么的时候翻一翻总能找到好片。希望片库越来越丰富！',
    date: '2026-07-18',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">用户口碑</h2>
          <p className="mt-2 text-sm text-foreground-500">真实影迷的使用评价，口碑是最好的证明</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((c) => (
            <div
              key={c.name}
              className="p-5 rounded-lg bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-1.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < c.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{c.text}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-foreground-700">{c.name}</span>
                <span className="text-xs text-foreground-400">{c.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}